// for routing history
export const START_AT_SLUG = 'gather-return-info'

// animations
export const ANIMATE_IN = 'animated slow slideInUp delay-2s'
export const ANIMATE_OUT = 'animated slow slideOutDown'

// Media Types for Return Process
export const MEDIA_TYPES = {
  BOX: 'BOX',
  PRODUCT: 'PRODUCT',
  DAMAGE: 'DAMAGE',
  PRODUCT_TAG: 'PRODUCT_TAG',
  PACKAGING_DIMENSIONS: 'PACKAGING_DIMENSIONS', // Box photos with size reference for dimension extraction
}

// Image constants
export const MAX_IMAGE_PIXELS = 1500 // longest side of an image in pixels. Images will be resized to fit within this size

// Default photo object when handle photos
export const DEFAULT_PHOTO = {
  id: null,
  imageData: null, // base64 image data
  mimeType: null, // mime type of the image: 'image/jpeg', 'image/png', etc.
  mediaType: null, // type of photo: BOX, PRODUCT, DAMAGE, etc
  timestamp: null,
  size: null, // size in bytes
  error: null,
  uploading: false,
  uploaded: false,
  progress: 0,
  isValid: null, // AI validation result: true = valid, false = failed validation, null = not yet validated
  uploadIsValid: null,
  imageDescription: null,
  userAcknowledgedError: false,
}

// prompts
export const GO_BACK_PROMPT = 'I made a mistake in my previous response. Please go back to the previous conversation stage.'

// Resolution choice values for the exchange/replacement interface (conversationStage === 'resolutionChoice').
// Sent back to gather-return-info as `customerReply.resolutionChoice` when the customer decides how to
// resolve a return they no longer want to keep. Values are UPPER_SNAKE_CASE and MUST mirror the
// server-side resolutionChoice enum exactly (REPLACEMENT / DIFFERENT_ITEM / REFUND_FALLBACK). The
// backend rejects anything outside that enum: a non-matching value leaves resolution_choice NULL in
// the DB and bypasses the resolution-choice → credit-method-selection handoff (PEG-855).
export const RESOLUTION_CHOICES = {
  REPLACEMENT: 'REPLACEMENT', // ship the same item again
  DIFFERENT_ITEM: 'DIFFERENT_ITEM', // use credit to choose a different item
  // Customer declined a replacement/different item — fall back to a refund/store credit. The wire
  // value is REFUND_FALLBACK (NOT "DECLINE"); the customer-facing copy still comes from the API's
  // `declineButtonText`.
  REFUND_FALLBACK: 'REFUND_FALLBACK',
}

// PEG-855: Credit-method values for the credit-method-selection interface
// (conversationStage === 'creditMethodSelection'). Presented per item only when
// the customer's return entitles them to a refund; offers a choice between store
// credit and a refund to the original payment method. Sent back to
// gather-return-info as `customerReply.creditMethod`. Values are UPPER_SNAKE_CASE
// to match the server-side enum (credit_destination: STORE_CREDIT -> store
// credit, REFUND -> refund to original payment).
export const CREDIT_METHODS = {
  STORE_CREDIT: 'STORE_CREDIT', // store credit to re-shop on the retailer's site
  REFUND: 'REFUND', // refund to the customer's original payment method
}

// return eligibility messages
export const RETURN_ELIGIBILITY_MESSAGES = {
  FINAL_SALE: 'Final sale item. This item cannot be returned.',
  OUTSIDE_POLICY: "Outside the retailer's return policy.",
  OUTSIDE_POLICY_NOT_ENFORCED: '', // Return window expired but enforcement is disabled — allow return with no message
  REFUND_ONLY: 'Eligible for return for a full refund.',
  STORE_CREDIT_ONLY: 'Eligible for return for in-store credit only.',
  BOTH_OPTIONS: '', // Empty when both refund and store credit are available since we dont need to message to the customer
}

// loading messages
export const RETURN_POLICY_LOADING_MESSAGE = ['Getting Return Policy...', 'Verifying Dates...', 'Finalizing...']
export const FETCH_LOCATION_MESSAGE = ['Getting Location...']
export const ORDER_LOOKUP_LOADING_MESSAGES = ['Looking up order...', 'Verifying details...', 'Almost there...']
export const CHOOSE_ITEM_LOADING_MESSAGES = ['Initializing return process...', 'Preparing data...', 'Almost done...']
export const NEXT_QUESTION_LOADING_MESSAGES = [
  ['Saving reply...', 'Getting next step...', 'Just a bit longer...'],
  ['Processing response...', 'Finding next question...', 'Almost ready...'],
  ['Recording answer...', 'Moving forward...', 'Hang tight...'],
  ['Updating progress...', 'Loading next stage...', 'Nearly there...'],
  ['Capturing input...', 'Preparing continuation...', 'One moment more...'],
]
export const SUBMIT_RETURN_LOADING_MESSAGES = ['Gathering data...', 'Submitting return...', 'Finalizing...']
